<template>
  <div class="wap_index6 main">
    <div class="wap_index6_title">合作流程②</div>
    <div class="wap_index600_main2">
      <div class="wap_index600_main2_box">
        <div class="wap_index600_main2_box1">
          <div></div>
          <div>若您自有引擎版本或已有正式上线存量版本或存量用户</div>
        </div>
        <div class="wap_index600_main2_box2">
          我们为您开发了千年引擎转换工具，便捷实现数据，资源转化，快速移植原版资源，具体合作细则您可咨询商务人员
        </div>
      </div>
      <div class="wap_index6_gif"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.wap_index6 {
  background-image: url("../../assets/images/web/cooperation.jpg");
}

.wap_index600_main2{
    box-sizing: border-box;
    width: 90%;
    margin: 0 auto;
    height: 3.706667rem /* 139/37.5 */;
    padding: .213333rem /* 8/37.5 */ .266667rem /* 10/37.5 */;
    border-radius: 0.4rem /* 15/37.5 */;
    border: 1px solid #707070;
}
.wap_index600_main2_box{
    background: #575757;
    border-radius: .133333rem /* 5/37.5 */;
    padding: .186667rem /* 7/37.5 */ .266667rem /* 10/37.5 */;
    height: 100%;
    box-sizing: border-box;
}
.wap_index600_main2_box1{
    display: flex;
    font-size: .346667rem /* 13/37.5 */;
    color: #fff;
    font-weight: bold;
    align-items: center;
}
.wap_index600_main2_box1>div:nth-child(1){
    width: .64rem /* 24/37.5 */;
    height: .72rem /* 27/37.5 */;
    background: url("../../assets/images/pc/bb.png") no-repeat center;
    background-size: contain;
    margin-right: .266667rem /* 10/37.5 */;
}

.wap_index600_main2_box2{
    padding-top: .32rem /* 12/37.5 */;
    padding-bottom: .4rem /* 15/37.5 */;
    font-size: .32rem /* 12/37.5 */;
    color: #B1B1B1;
    line-height: .48rem /* 18/37.5 */;
}
.wap_index6_gif{
    margin: 0 auto;
    margin-top: .533333rem /* 20/37.5 */;
    width: 7.466667rem /* 280/37.5 */;
    height: 6.8rem /* 255/37.5 */;
    background: url("../../assets/images//web/wap_index6_bg.gif") no-repeat center;
    background-size: cover;
    opacity: 0.45;
}
</style>
